import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Container, Row, Col, Button } from 'react-bootstrap';

import './PopUpPage.css';

import NavBar from '@/components/layout/NavBar/NavBar';

export default function PopUpPage(props) {
    const detail = props?.detail;

    // require() must be anchored to `../../assets/` — a dynamic `../../${var}`
    // makes webpack bundle the entire src/ tree (including test files) into
    // production. Anchoring to assets/ keeps the context scoped to image assets.
    const handleImageSource = () => {
        if (!detail?.imgSrc) {
            return '';
        } else if (detail.imgSrc.startsWith('http')) {
            return detail.imgSrc;
        } else if (detail.imgSrc.startsWith('assets/')) {
            const assetPath = detail.imgSrc.slice('assets/'.length);
            return require(`../../assets/${assetPath}`);
        } else {
            return require(`../../assets/project/${detail.imgSrc}`);
        }
    };

    if (!detail) {
        return <div>No details found.</div>;
    }
    const imagePath = handleImageSource();
    return (
        <Modal
            {...props}
            fullscreen
            className="pop-modal"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <NavBar />

            <Modal.Body className="bg-light">
                <Container>
                    <Row>
                        <Modal.Title
                            id="contained-modal-title-vcenter"
                            className="  text-center display-6 fw-bold"
                        >
                            {detail?.title}
                        </Modal.Title>
                        {detail.author && (
                            <p className="text-muted text-center h5 mt-2">
                                By {detail.author}
                            </p>
                        )}
                    </Row>
                    <Row className="text-center gx-5">
                        <Col
                            sm={12}
                            md={12}
                            lg={6}
                            className="popup-image my-3"
                        >
                            <img
                                src={imagePath}
                                alt={
                                    detail?.title
                                        ? `Highlight image for ${detail.title}`
                                        : 'Sustainability Hub highlight'
                                }
                            />
                        </Col>
                        <Col md={12} lg={6} className="popup-detail">
                            <div className="project-subHeadings text-start mt-4">
                                {detail.body?.map((section, index) => {
                                    if (typeof section === 'string') {
                                        return <p key={index}>{section}</p>;
                                    } else if (typeof section === 'object') {
                                        return (
                                            <div key={index}>
                                                {section.subHeading && (
                                                    <h3 className="h5">
                                                        {section.subHeading}
                                                    </h3>
                                                )}
                                                {section.content &&
                                                    section.content.map(
                                                        (paragraph, idx) => (
                                                            <p key={idx}>
                                                                {paragraph}
                                                            </p>
                                                        )
                                                    )}
                                            </div>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>

            <Modal.Footer className="bg-light">
                <Button
                    onClick={props.onHide}
                    className="m-auto pop-back-button"
                >
                    Back
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

PopUpPage.propTypes = {
    detail: PropTypes.shape({
        imgSrc: PropTypes.string,
        title: PropTypes.string,
        author: PropTypes.string,
        body: PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.shape({
                    subHeading: PropTypes.string,
                    content: PropTypes.arrayOf(PropTypes.string),
                }),
            ])
        ).isRequired,
    }).isRequired,
    onHide: PropTypes.func.isRequired,
};
